<template>
  <div class="common-loading">
    <div class="loading">
      <div><span></span></div>
      <div><span></span></div>
      <div><span></span></div>
    </div>
    <div class="tips" v-if="!searchingProps.status">快速加载中...</div>
    <div class="tips" v-else>正在搜索中...</div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "Loaidng",
  props: {
        searchingProps: {
            type: Object,
            default () {
                return {
                    status: false,
                    keyVal: '',
                    type: '模板'
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.common-loading {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .tips {
    font-size: 12px;
    color: #999;
    line-height: 16px;
    margin-left: 18px;
  }
}
.loading {
  width: 6px;
  height: 6px;
  position: relative;
  animation: load 3s linear infinite;
}
.loading div {
  width: 100%;
  height: 100%;
  position: absolute;
}
.loading span {
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0062ff;
  position: absolute;
  left: 0;
  top: 8px;
  animation: changeBgColor 3s ease infinite;
}
.loading div:nth-child(2) {
  // transform: translate(10px, 0);
  transform: rotate(120deg);
}
.loading div:nth-child(3) {
  // transform: translate(20px, 0);
  transform: rotate(240deg);
}
.loading div:nth-child(2) span {
  animation-delay: 1s;
}
.loading div:nth-child(3) span {
  animation-delay: 2s;
}
@keyframes load {
  0% {
    transform: rotate(0deg);
  }
  33.3% {
    transform: rotate(120deg);
  }
  66.6% {
    transform: rotate(240deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes changeBgColor {
  0%,
  100% {
    background: #0062ff;
  }
  33.3% {
    background: #7faffd;
  }
  66.6% {
    background: #cbdfff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/loading.vue